class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.isOpen = false;
  }
  getElements() {
    super.getElements();
    this.elements.loading = this.querySelector(".sm-loading");
    this.elements.predictiveSearchResults = document.querySelector("#predictive-search");
    this.elements.searches = this.querySelector(".sm-search-drawer__searches");
  }
  setupEventListeners() {
    super.setupEventListeners();
    this.elements.input.addEventListener(
      "input",
      window.debounce((event) => {
        this.onChange(event);
      }, 300)
    );
  }
  onChange() {
    const searchTerm = this.elements.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    var _a;
    this.open();
    this.setAttribute("data-loading", "true");
    (_a = this.elements.loading) == null ? void 0 : _a.classList.remove("hidden");
    fetch(`${routes.predictive_search_url}?q=${searchTerm}&resources[limit_scope]=each&section_id=predictive-search`).then((response) => {
      if (!response.ok) {
        this.close();
        throw new Error(response.status);
      }
      return response.text();
    }).then((text) => {
      var _a2;
      const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
      this.elements.predictiveSearchResults.innerHTML = resultsMarkup;
      window.publish(window.PUB_SUB_EVENTS.listRenderCompleted, {
        source: this
      });
      (_a2 = this.elements.searches) == null ? void 0 : _a2.classList.add("hidden");
    }).catch((error) => {
      this.close();
      throw error;
    }).finally(() => {
      var _a2;
      this.setAttribute("data-loading", "false");
      (_a2 = this.elements.loading) == null ? void 0 : _a2.classList.add("hidden");
    });
  }
  open() {
    this.elements.predictiveSearchResults.style.display = "block";
    this.isOpen = true;
  }
  close() {
    var _a;
    this.elements.predictiveSearchResults.innerHTML = "";
    this.elements.predictiveSearchResults.style.display = "none";
    (_a = this.elements.searches) == null ? void 0 : _a.classList.remove("hidden");
    this.isOpen = false;
  }
}
customElements.define("predictive-search", PredictiveSearch);
